import {ProductSearchHit} from '../../store/data/productSearchResult/interface';
import ProductSearchHitModel from './ProductSearchHitModel';
import ManagerRepository from 'coreClasses/ManagerRepository';

/**
 * Represents SearchModelPage
 */
class SearchModelPage {
	private ManagerRepository: ManagerRepository;
	private pageNumber: number;
	private hits: ProductSearchHit[];

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {number} pageNumber - page number
	 * @param {ProductSearchResultType[]} hits - product search hits
	 */
	constructor(managerRepository: ManagerRepository, pageNumber: number, hits: ProductSearchHit[]) {
		this.pageNumber = pageNumber;
		this.ManagerRepository = managerRepository;
		this.hits = hits || []; // TODO, remove fallback once pagination is perfect
	}

	/**
	 * Returns all ProductSearchHits contained in the current page
	 * @return ProductSearchHitModel[]
	 */
	getHits() : ProductSearchHitModel[] {
		return this.hits.map((h) => new ProductSearchHitModel(this.ManagerRepository, h));
	};

	/**
	 * Returns the current page number
	 * @return number
	 */
	getPageNumber() : number {
		return this.pageNumber;
	};
}

export default SearchModelPage;
